var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from "@apollo/client";
import { useMemo } from "react";
import { useEnhancedQuery } from "./hooks";
export var ENUM_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query EnumData($enumName: String!) {\n    enumData: __type(name: $enumName) {\n      name\n      enumValues {\n        name\n        description\n      }\n    }\n  }\n"], ["\n  query EnumData($enumName: String!) {\n    enumData: __type(name: $enumName) {\n      name\n      enumValues {\n        name\n        description\n      }\n    }\n  }\n"])));
export var useEnumValues = function (enumName) {
    var _a = useEnhancedQuery(ENUM_QUERY, {
        variables: { enumName: enumName },
    }), data = _a.data, loading = _a.loading, error = _a.error;
    var dataMap = useMemo(function () {
        var _a;
        if (loading || error || !((_a = data === null || data === void 0 ? void 0 : data.enumData) === null || _a === void 0 ? void 0 : _a.enumValues)) {
            return {};
        }
        return data.enumData.enumValues.reduce(function (acc, e) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[e.name] = e.description, _a)));
        }, {});
    }, [data, loading, error]);
    return dataMap;
};
var templateObject_1;
